import { LoadableItem } from '@trimble/data-loading';
import { PointcloudStatus } from '@data-access/geospatial/scan-data';

type PointCloudItemBase = LoadableItem & {
  name: string;
  status: PointcloudStatus;
  classStatistics?: Record<number, number>;
};

/** Optional source so existing ScanData call sites keep compiling. */
export type ScanDataPointCloudItem = PointCloudItemBase & {
  source?: 'scanData';
};

export type MissionPointCloudItem = PointCloudItemBase & {
  source: 'mission';
  missionTrn: string;
  /** Scan Data project id from the point-cloud URL when parseable. */
  projectId?: string;
};

export type PointCloudItem = ScanDataPointCloudItem | MissionPointCloudItem;

export function isMissionPointCloud(
  item: PointCloudItem
): item is MissionPointCloudItem {
  return item.source === 'mission';
}
